import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

type CompositionCategories = {
    id: number
    title: string  
    value: string
    compositions: any
}

type CompositionCategoriesDto = {
    title: string  
    value: string
}

export const CompositionCategoriesApi = createApi({
    reducerPath: 'CompositionCategoriesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["COMPOSITION-CATEGORIES"],
    endpoints: builder => ({
        getCompositionCategories: builder.query<CompositionCategories, { id: number }>({
            query: id => ({ url: `/composition-categories/${id}` }),
            providesTags: ["COMPOSITION-CATEGORIES"]
        }),
        getAllCompositionCategories: builder.query<CompositionCategories[], void>({
            query: () => ({ url: '/composition-categories' }),
            providesTags: ["COMPOSITION-CATEGORIES"]
        }),
        createCompositionCategories: builder.mutation<any, CompositionCategoriesDto>({
            query: (data)=> ({url: `/composition-categories`, method: "POST", body: data}),
            invalidatesTags: ["COMPOSITION-CATEGORIES"]
        }),
    })
})

export const { useGetCompositionCategoriesQuery, useGetAllCompositionCategoriesQuery, useCreateCompositionCategoriesMutation } = CompositionCategoriesApi
